export const iso2Countries: {
    [key: string]: { ioc: string | null; iso3: string | null };
} = {
    TW: { ioc: 'TPE', iso3: 'TWN' },
    AF: { ioc: 'AFG', iso3: 'AFG' },
    AL: { ioc: 'ALB', iso3: 'ALB' },
    DZ: { ioc: 'ALG', iso3: 'DZA' },
    AS: { ioc: 'ASA', iso3: 'ASM' },
    AD: { ioc: 'AND', iso3: 'AND' },
    AO: { ioc: 'ANG', iso3: 'AGO' },
    AI: { ioc: 'AIA', iso3: 'AIA' },
    AQ: { ioc: null, iso3: 'ATA' },
    AG: { ioc: 'ANT', iso3: 'ATG' },
    AR: { ioc: 'ARG', iso3: 'ARG' },
    AM: { ioc: 'ARM', iso3: 'ARM' },
    AW: { ioc: 'ARU', iso3: 'ABW' },
    AU: { ioc: 'AUS', iso3: 'AUS' },
    AT: { ioc: 'AUT', iso3: 'AUT' },
    AZ: { ioc: 'AZE', iso3: 'AZE' },
    BS: { ioc: 'BAH', iso3: 'BHS' },
    BH: { ioc: 'BRN', iso3: 'BHR' },
    BD: { ioc: 'BAN', iso3: 'BGD' },
    BB: { ioc: 'BAR', iso3: 'BRB' },
    BY: { ioc: 'BLR', iso3: 'BLR' },
    BE: { ioc: 'BEL', iso3: 'BEL' },
    BZ: { ioc: 'BIZ', iso3: 'BLZ' },
    BJ: { ioc: 'BEN', iso3: 'BEN' },
    BM: { ioc: 'BER', iso3: 'BMU' },
    BT: { ioc: 'BHU', iso3: 'BTN' },
    BO: { ioc: 'BOL', iso3: 'BOL' },
    BQ: { ioc: 'AHO', iso3: 'BES' },
    BA: { ioc: 'BIH', iso3: 'BIH' },
    BW: { ioc: 'BOT', iso3: 'BWA' },
    BV: { ioc: null, iso3: 'BVT' },
    BR: { ioc: 'BRA', iso3: 'BRA' },
    IO: { ioc: null, iso3: 'IOT' },
    VG: { ioc: 'IVB', iso3: 'VGB' },
    BN: { ioc: 'BRU', iso3: 'BRN' },
    BG: { ioc: 'BUL', iso3: 'BGR' },
    BF: { ioc: 'BUR', iso3: 'BFA' },
    BI: { ioc: 'BDI', iso3: 'BDI' },
    CV: { ioc: 'CPV', iso3: 'CPV' },
    KH: { ioc: 'CAM', iso3: 'KHM' },
    CM: { ioc: 'CMR', iso3: 'CMR' },
    CA: { ioc: 'CAN', iso3: 'CAN' },
    KY: { ioc: 'CAY', iso3: 'CYM' },
    CF: { ioc: 'CAF', iso3: 'CAF' },
    TD: { ioc: 'CHA', iso3: 'TCD' },
    CL: { ioc: 'CHI', iso3: 'CHL' },
    CN: { ioc: 'CHN', iso3: 'CHN' },
    HK: { ioc: 'HKG', iso3: 'HKG' },
    MO: { ioc: 'MAC', iso3: 'MAC' },
    CX: { ioc: null, iso3: 'CXR' },
    CC: { ioc: null, iso3: 'CCK' },
    CO: { ioc: 'COL', iso3: 'COL' },
    KM: { ioc: 'COM', iso3: 'COM' },
    CG: { ioc: 'CGO', iso3: 'COG' },
    CK: { ioc: 'COK', iso3: 'COK' },
    CR: { ioc: 'CRC', iso3: 'CRI' },
    HR: { ioc: 'CRO', iso3: 'HRV' },
    CU: { ioc: 'CUB', iso3: 'CUB' },
    CW: { ioc: null, iso3: 'CUW' },
    CY: { ioc: 'CYP', iso3: 'CYP' },
    CZ: { ioc: 'CZE', iso3: 'CZE' },
    CI: { ioc: 'CIV', iso3: 'CIV' },
    KP: { ioc: 'PRK', iso3: 'PRK' },
    CD: { ioc: 'COD', iso3: 'COD' },
    DK: { ioc: 'DEN', iso3: 'DNK' },
    DJ: { ioc: 'DJI', iso3: 'DJI' },
    DM: { ioc: 'DMA', iso3: 'DMA' },
    DO: { ioc: 'DOM', iso3: 'DOM' },
    EC: { ioc: 'ECU', iso3: 'ECU' },
    EG: { ioc: 'EGY', iso3: 'EGY' },
    SV: { ioc: 'ESA', iso3: 'SLV' },
    GQ: { ioc: 'GEQ', iso3: 'GNQ' },
    ER: { ioc: 'ERI', iso3: 'ERI' },
    EE: { ioc: 'EST', iso3: 'EST' },
    ET: { ioc: 'ETH', iso3: 'ETH' },
    FK: { ioc: 'FLK', iso3: 'FLK' },
    FO: { ioc: 'FAR', iso3: 'FRO' },
    FJ: { ioc: 'FIJ', iso3: 'FJI' },
    FI: { ioc: 'FIN', iso3: 'FIN' },
    FR: { ioc: 'FRA', iso3: 'FRA' },
    GF: { ioc: 'FGU', iso3: 'GUF' },
    PF: { ioc: 'FPO', iso3: 'PYF' },
    TF: { ioc: null, iso3: 'ATF' },
    GA: { ioc: 'GAB', iso3: 'GAB' },
    GM: { ioc: 'GAM', iso3: 'GMB' },
    GE: { ioc: 'GEO', iso3: 'GEO' },
    DE: { ioc: 'GER', iso3: 'DEU' },
    GH: { ioc: 'GHA', iso3: 'GHA' },
    GI: { ioc: 'GIB', iso3: 'GIB' },
    GR: { ioc: 'GRE', iso3: 'GRC' },
    GL: { ioc: 'GRL', iso3: 'GRL' },
    GD: { ioc: 'GRN', iso3: 'GRD' },
    GP: { ioc: 'GUD', iso3: 'GLP' },
    GU: { ioc: 'GUM', iso3: 'GUM' },
    GT: { ioc: 'GUA', iso3: 'GTM' },
    GG: { ioc: null, iso3: 'GGY' },
    GN: { ioc: 'GUI', iso3: 'GIN' },
    GW: { ioc: 'GBS', iso3: 'GNB' },
    GY: { ioc: 'GUY', iso3: 'GUY' },
    HT: { ioc: 'HAI', iso3: 'HTI' },
    HM: { ioc: null, iso3: 'HMD' },
    VA: { ioc: null, iso3: 'VAT' },
    HN: { ioc: 'HON', iso3: 'HND' },
    HU: { ioc: 'HUN', iso3: 'HUN' },
    IS: { ioc: 'ISL', iso3: 'ISL' },
    IN: { ioc: 'IND', iso3: 'IND' },
    ID: { ioc: 'INA', iso3: 'IDN' },
    IR: { ioc: 'IRI', iso3: 'IRN' },
    IQ: { ioc: 'IRQ', iso3: 'IRQ' },
    IE: { ioc: 'IRL', iso3: 'IRL' },
    IM: { ioc: null, iso3: 'IMN' },
    IL: { ioc: 'ISR', iso3: 'ISR' },
    IT: { ioc: 'ITA', iso3: 'ITA' },
    JM: { ioc: 'JAM', iso3: 'JAM' },
    JP: { ioc: 'JPN', iso3: 'JPN' },
    JE: { ioc: null, iso3: 'JEY' },
    JO: { ioc: 'JOR', iso3: 'JOR' },
    KZ: { ioc: 'KAZ', iso3: 'KAZ' },
    KE: { ioc: 'KEN', iso3: 'KEN' },
    KI: { ioc: 'KIR', iso3: 'KIR' },
    KW: { ioc: 'KUW', iso3: 'KWT' },
    KG: { ioc: 'KGZ', iso3: 'KGZ' },
    LA: { ioc: 'LAO', iso3: 'LAO' },
    LV: { ioc: 'LAT', iso3: 'LVA' },
    LB: { ioc: 'LIB', iso3: 'LBN' },
    LS: { ioc: 'LES', iso3: 'LSO' },
    LR: { ioc: 'LBR', iso3: 'LBR' },
    LY: { ioc: 'LBA', iso3: 'LBY' },
    LI: { ioc: 'LIE', iso3: 'LIE' },
    LT: { ioc: 'LTU', iso3: 'LTU' },
    LU: { ioc: 'LUX', iso3: 'LUX' },
    MG: { ioc: 'MAD', iso3: 'MDG' },
    MW: { ioc: 'MAW', iso3: 'MWI' },
    MY: { ioc: 'MAS', iso3: 'MYS' },
    MV: { ioc: 'MDV', iso3: 'MDV' },
    ML: { ioc: 'MLI', iso3: 'MLI' },
    MT: { ioc: 'MLT', iso3: 'MLT' },
    MH: { ioc: 'MSH', iso3: 'MHL' },
    MQ: { ioc: 'MRT', iso3: 'MTQ' },
    MR: { ioc: 'MTN', iso3: 'MRT' },
    MU: { ioc: 'MRI', iso3: 'MUS' },
    YT: { ioc: 'MAY', iso3: 'MYT' },
    MX: { ioc: 'MEX', iso3: 'MEX' },
    FM: { ioc: 'FSM', iso3: 'FSM' },
    MC: { ioc: 'MON', iso3: 'MCO' },
    MN: { ioc: 'MGL', iso3: 'MNG' },
    ME: { ioc: 'MGO', iso3: 'MNE' },
    MS: { ioc: 'MNT', iso3: 'MSR' },
    MA: { ioc: 'MAR', iso3: 'MAR' },
    MZ: { ioc: 'MOZ', iso3: 'MOZ' },
    MM: { ioc: 'MYA', iso3: 'MMR' },
    NA: { ioc: 'NAM', iso3: 'NAM' },
    NR: { ioc: 'NRU', iso3: 'NRU' },
    NP: { ioc: 'NEP', iso3: 'NPL' },
    NL: { ioc: 'NED', iso3: 'NLD' },
    NC: { ioc: 'NCD', iso3: 'NCL' },
    NZ: { ioc: 'NZL', iso3: 'NZL' },
    NI: { ioc: 'NCA', iso3: 'NIC' },
    NE: { ioc: 'NIG', iso3: 'NER' },
    NG: { ioc: 'NGR', iso3: 'NGA' },
    NU: { ioc: 'NIU', iso3: 'NIU' },
    NF: { ioc: 'NFI', iso3: 'NFK' },
    MP: { ioc: 'NMA', iso3: 'MNP' },
    NO: { ioc: 'NOR', iso3: 'NOR' },
    OM: { ioc: 'OMA', iso3: 'OMN' },
    PK: { ioc: 'PAK', iso3: 'PAK' },
    PW: { ioc: 'PLW', iso3: 'PLW' },
    PA: { ioc: 'PAN', iso3: 'PAN' },
    PG: { ioc: 'PNG', iso3: 'PNG' },
    PY: { ioc: 'PAR', iso3: 'PRY' },
    PE: { ioc: 'PER', iso3: 'PER' },
    PH: { ioc: 'PHI', iso3: 'PHL' },
    PN: { ioc: null, iso3: 'PCN' },
    PL: { ioc: 'POL', iso3: 'POL' },
    PT: { ioc: 'POR', iso3: 'PRT' },
    PR: { ioc: 'PUR', iso3: 'PRI' },
    QA: { ioc: 'QAT', iso3: 'QAT' },
    KR: { ioc: 'KOR', iso3: 'KOR' },
    MD: { ioc: 'MDA', iso3: 'MDA' },
    RO: { ioc: 'ROU', iso3: 'ROU' },
    RU: { ioc: 'RUS', iso3: 'RUS' },
    RW: { ioc: 'RWA', iso3: 'RWA' },
    RE: { ioc: 'REU', iso3: 'REU' },
    BL: { ioc: null, iso3: 'BLM' },
    SH: { ioc: 'HEL', iso3: 'SHN' },
    KN: { ioc: 'SKN', iso3: 'KNA' },
    LC: { ioc: 'LCA', iso3: 'LCA' },
    MF: { ioc: null, iso3: 'MAF' },
    PM: { ioc: 'SPM', iso3: 'SPM' },
    VC: { ioc: 'VIN', iso3: 'VCT' },
    WS: { ioc: 'SAM', iso3: 'WSM' },
    SM: { ioc: 'SMR', iso3: 'SMR' },
    ST: { ioc: 'STP', iso3: 'STP' },
    null: { ioc: null, iso3: null },
    SA: { ioc: 'KSA', iso3: 'SAU' },
    SN: { ioc: 'SEN', iso3: 'SEN' },
    RS: { ioc: 'SRB', iso3: 'SRB' },
    SC: { ioc: 'SEY', iso3: 'SYC' },
    SL: { ioc: 'SLE', iso3: 'SLE' },
    SG: { ioc: 'SIN', iso3: 'SGP' },
    SX: { ioc: null, iso3: 'SXM' },
    SK: { ioc: 'SVK', iso3: 'SVK' },
    SI: { ioc: 'SLO', iso3: 'SVN' },
    SB: { ioc: 'SOL', iso3: 'SLB' },
    SO: { ioc: 'SOM', iso3: 'SOM' },
    ZA: { ioc: 'RSA', iso3: 'ZAF' },
    GS: { ioc: null, iso3: 'SGS' },
    SS: { ioc: null, iso3: 'SSD' },
    ES: { ioc: 'ESP', iso3: 'ESP' },
    LK: { ioc: 'SRI', iso3: 'LKA' },
    PS: { ioc: 'PLE', iso3: 'PSE' },
    SD: { ioc: 'SUD', iso3: 'SDN' },
    SR: { ioc: 'SUR', iso3: 'SUR' },
    SJ: { ioc: null, iso3: 'SJM' },
    SZ: { ioc: 'SWZ', iso3: 'SWZ' },
    SE: { ioc: 'SWE', iso3: 'SWE' },
    CH: { ioc: 'SUI', iso3: 'CHE' },
    SY: { ioc: 'SYR', iso3: 'SYR' },
    TJ: { ioc: 'TJK', iso3: 'TJK' },
    TH: { ioc: 'THA', iso3: 'THA' },
    MK: { ioc: 'MKD', iso3: 'MKD' },
    TL: { ioc: 'TLS', iso3: 'TLS' },
    TG: { ioc: 'TOG', iso3: 'TGO' },
    TK: { ioc: null, iso3: 'TKL' },
    TO: { ioc: 'TGA', iso3: 'TON' },
    TT: { ioc: 'TTO', iso3: 'TTO' },
    TN: { ioc: 'TUN', iso3: 'TUN' },
    TR: { ioc: 'TUR', iso3: 'TUR' },
    TM: { ioc: 'TKM', iso3: 'TKM' },
    TC: { ioc: 'TKS', iso3: 'TCA' },
    TV: { ioc: 'TUV', iso3: 'TUV' },
    UG: { ioc: 'UGA', iso3: 'UGA' },
    UA: { ioc: 'UKR', iso3: 'UKR' },
    AE: { ioc: 'UAE', iso3: 'ARE' },
    GB: { ioc: 'GBR', iso3: 'GBR' },
    TZ: { ioc: 'TAN', iso3: 'TZA' },
    UM: { ioc: null, iso3: 'UMI' },
    VI: { ioc: 'ISV', iso3: 'VIR' },
    US: { ioc: 'USA', iso3: 'USA' },
    UY: { ioc: 'URU', iso3: 'URY' },
    UZ: { ioc: 'UZB', iso3: 'UZB' },
    VU: { ioc: 'VAN', iso3: 'VUT' },
    VE: { ioc: 'VEN', iso3: 'VEN' },
    VN: { ioc: 'VIE', iso3: 'VNM' },
    WF: { ioc: 'WAF', iso3: 'WLF' },
    EH: { ioc: null, iso3: 'ESH' },
    YE: { ioc: 'YEM', iso3: 'YEM' },
    ZM: { ioc: 'ZAM', iso3: 'ZMB' },
    ZW: { ioc: 'ZIM', iso3: 'ZWE' },
    AX: { ioc: null, iso3: 'ALA' },
};

export const iso3Countries: {
    [key: string]: { ioc: string | null; iso2: string | null };
} = {
    TWN: { ioc: 'TPE', iso2: 'TW' },
    AFG: { ioc: 'AFG', iso2: 'AF' },
    ALB: { ioc: 'ALB', iso2: 'AL' },
    DZA: { ioc: 'ALG', iso2: 'DZ' },
    ASM: { ioc: 'ASA', iso2: 'AS' },
    AND: { ioc: 'AND', iso2: 'AD' },
    AGO: { ioc: 'ANG', iso2: 'AO' },
    AIA: { ioc: 'AIA', iso2: 'AI' },
    ATA: { ioc: null, iso2: 'AQ' },
    ATG: { ioc: 'ANT', iso2: 'AG' },
    ARG: { ioc: 'ARG', iso2: 'AR' },
    ARM: { ioc: 'ARM', iso2: 'AM' },
    ABW: { ioc: 'ARU', iso2: 'AW' },
    AUS: { ioc: 'AUS', iso2: 'AU' },
    AUT: { ioc: 'AUT', iso2: 'AT' },
    AZE: { ioc: 'AZE', iso2: 'AZ' },
    BHS: { ioc: 'BAH', iso2: 'BS' },
    BHR: { ioc: 'BRN', iso2: 'BH' },
    BGD: { ioc: 'BAN', iso2: 'BD' },
    BRB: { ioc: 'BAR', iso2: 'BB' },
    BLR: { ioc: 'BLR', iso2: 'BY' },
    BEL: { ioc: 'BEL', iso2: 'BE' },
    BLZ: { ioc: 'BIZ', iso2: 'BZ' },
    BEN: { ioc: 'BEN', iso2: 'BJ' },
    BMU: { ioc: 'BER', iso2: 'BM' },
    BTN: { ioc: 'BHU', iso2: 'BT' },
    BOL: { ioc: 'BOL', iso2: 'BO' },
    BES: { ioc: 'AHO', iso2: 'BQ' },
    BIH: { ioc: 'BIH', iso2: 'BA' },
    BWA: { ioc: 'BOT', iso2: 'BW' },
    BVT: { ioc: null, iso2: 'BV' },
    BRA: { ioc: 'BRA', iso2: 'BR' },
    IOT: { ioc: null, iso2: 'IO' },
    VGB: { ioc: 'IVB', iso2: 'VG' },
    BRN: { ioc: 'BRU', iso2: 'BN' },
    BGR: { ioc: 'BUL', iso2: 'BG' },
    BFA: { ioc: 'BUR', iso2: 'BF' },
    BDI: { ioc: 'BDI', iso2: 'BI' },
    CPV: { ioc: 'CPV', iso2: 'CV' },
    KHM: { ioc: 'CAM', iso2: 'KH' },
    CMR: { ioc: 'CMR', iso2: 'CM' },
    CAN: { ioc: 'CAN', iso2: 'CA' },
    CYM: { ioc: 'CAY', iso2: 'KY' },
    CAF: { ioc: 'CAF', iso2: 'CF' },
    TCD: { ioc: 'CHA', iso2: 'TD' },
    CHL: { ioc: 'CHI', iso2: 'CL' },
    CHN: { ioc: 'CHN', iso2: 'CN' },
    HKG: { ioc: 'HKG', iso2: 'HK' },
    MAC: { ioc: 'MAC', iso2: 'MO' },
    CXR: { ioc: null, iso2: 'CX' },
    CCK: { ioc: null, iso2: 'CC' },
    COL: { ioc: 'COL', iso2: 'CO' },
    COM: { ioc: 'COM', iso2: 'KM' },
    COG: { ioc: 'CGO', iso2: 'CG' },
    COK: { ioc: 'COK', iso2: 'CK' },
    CRI: { ioc: 'CRC', iso2: 'CR' },
    HRV: { ioc: 'CRO', iso2: 'HR' },
    CUB: { ioc: 'CUB', iso2: 'CU' },
    CUW: { ioc: null, iso2: 'CW' },
    CYP: { ioc: 'CYP', iso2: 'CY' },
    CZE: { ioc: 'CZE', iso2: 'CZ' },
    CIV: { ioc: 'CIV', iso2: 'CI' },
    PRK: { ioc: 'PRK', iso2: 'KP' },
    COD: { ioc: 'COD', iso2: 'CD' },
    DNK: { ioc: 'DEN', iso2: 'DK' },
    DJI: { ioc: 'DJI', iso2: 'DJ' },
    DMA: { ioc: 'DMA', iso2: 'DM' },
    DOM: { ioc: 'DOM', iso2: 'DO' },
    ECU: { ioc: 'ECU', iso2: 'EC' },
    EGY: { ioc: 'EGY', iso2: 'EG' },
    SLV: { ioc: 'ESA', iso2: 'SV' },
    GNQ: { ioc: 'GEQ', iso2: 'GQ' },
    ERI: { ioc: 'ERI', iso2: 'ER' },
    EST: { ioc: 'EST', iso2: 'EE' },
    ETH: { ioc: 'ETH', iso2: 'ET' },
    FLK: { ioc: 'FLK', iso2: 'FK' },
    FRO: { ioc: 'FAR', iso2: 'FO' },
    FJI: { ioc: 'FIJ', iso2: 'FJ' },
    FIN: { ioc: 'FIN', iso2: 'FI' },
    FRA: { ioc: 'FRA', iso2: 'FR' },
    GUF: { ioc: 'FGU', iso2: 'GF' },
    PYF: { ioc: 'FPO', iso2: 'PF' },
    ATF: { ioc: null, iso2: 'TF' },
    GAB: { ioc: 'GAB', iso2: 'GA' },
    GMB: { ioc: 'GAM', iso2: 'GM' },
    GEO: { ioc: 'GEO', iso2: 'GE' },
    DEU: { ioc: 'GER', iso2: 'DE' },
    GHA: { ioc: 'GHA', iso2: 'GH' },
    GIB: { ioc: 'GIB', iso2: 'GI' },
    GRC: { ioc: 'GRE', iso2: 'GR' },
    GRL: { ioc: 'GRL', iso2: 'GL' },
    GRD: { ioc: 'GRN', iso2: 'GD' },
    GLP: { ioc: 'GUD', iso2: 'GP' },
    GUM: { ioc: 'GUM', iso2: 'GU' },
    GTM: { ioc: 'GUA', iso2: 'GT' },
    GGY: { ioc: null, iso2: 'GG' },
    GIN: { ioc: 'GUI', iso2: 'GN' },
    GNB: { ioc: 'GBS', iso2: 'GW' },
    GUY: { ioc: 'GUY', iso2: 'GY' },
    HTI: { ioc: 'HAI', iso2: 'HT' },
    HMD: { ioc: null, iso2: 'HM' },
    VAT: { ioc: null, iso2: 'VA' },
    HND: { ioc: 'HON', iso2: 'HN' },
    HUN: { ioc: 'HUN', iso2: 'HU' },
    ISL: { ioc: 'ISL', iso2: 'IS' },
    IND: { ioc: 'IND', iso2: 'IN' },
    IDN: { ioc: 'INA', iso2: 'ID' },
    IRN: { ioc: 'IRI', iso2: 'IR' },
    IRQ: { ioc: 'IRQ', iso2: 'IQ' },
    IRL: { ioc: 'IRL', iso2: 'IE' },
    IMN: { ioc: null, iso2: 'IM' },
    ISR: { ioc: 'ISR', iso2: 'IL' },
    ITA: { ioc: 'ITA', iso2: 'IT' },
    JAM: { ioc: 'JAM', iso2: 'JM' },
    JPN: { ioc: 'JPN', iso2: 'JP' },
    JEY: { ioc: null, iso2: 'JE' },
    JOR: { ioc: 'JOR', iso2: 'JO' },
    KAZ: { ioc: 'KAZ', iso2: 'KZ' },
    KEN: { ioc: 'KEN', iso2: 'KE' },
    KIR: { ioc: 'KIR', iso2: 'KI' },
    KWT: { ioc: 'KUW', iso2: 'KW' },
    KGZ: { ioc: 'KGZ', iso2: 'KG' },
    LAO: { ioc: 'LAO', iso2: 'LA' },
    LVA: { ioc: 'LAT', iso2: 'LV' },
    LBN: { ioc: 'LIB', iso2: 'LB' },
    LSO: { ioc: 'LES', iso2: 'LS' },
    LBR: { ioc: 'LBR', iso2: 'LR' },
    LBY: { ioc: 'LBA', iso2: 'LY' },
    LIE: { ioc: 'LIE', iso2: 'LI' },
    LTU: { ioc: 'LTU', iso2: 'LT' },
    LUX: { ioc: 'LUX', iso2: 'LU' },
    MDG: { ioc: 'MAD', iso2: 'MG' },
    MWI: { ioc: 'MAW', iso2: 'MW' },
    MYS: { ioc: 'MAS', iso2: 'MY' },
    MDV: { ioc: 'MDV', iso2: 'MV' },
    MLI: { ioc: 'MLI', iso2: 'ML' },
    MLT: { ioc: 'MLT', iso2: 'MT' },
    MHL: { ioc: 'MSH', iso2: 'MH' },
    MTQ: { ioc: 'MRT', iso2: 'MQ' },
    MRT: { ioc: 'MTN', iso2: 'MR' },
    MUS: { ioc: 'MRI', iso2: 'MU' },
    MYT: { ioc: 'MAY', iso2: 'YT' },
    MEX: { ioc: 'MEX', iso2: 'MX' },
    FSM: { ioc: 'FSM', iso2: 'FM' },
    MCO: { ioc: 'MON', iso2: 'MC' },
    MNG: { ioc: 'MGL', iso2: 'MN' },
    MNE: { ioc: 'MGO', iso2: 'ME' },
    MSR: { ioc: 'MNT', iso2: 'MS' },
    MAR: { ioc: 'MAR', iso2: 'MA' },
    MOZ: { ioc: 'MOZ', iso2: 'MZ' },
    MMR: { ioc: 'MYA', iso2: 'MM' },
    NAM: { ioc: 'NAM', iso2: 'NA' },
    NRU: { ioc: 'NRU', iso2: 'NR' },
    NPL: { ioc: 'NEP', iso2: 'NP' },
    NLD: { ioc: 'NED', iso2: 'NL' },
    NCL: { ioc: 'NCD', iso2: 'NC' },
    NZL: { ioc: 'NZL', iso2: 'NZ' },
    NIC: { ioc: 'NCA', iso2: 'NI' },
    NER: { ioc: 'NIG', iso2: 'NE' },
    NGA: { ioc: 'NGR', iso2: 'NG' },
    NIU: { ioc: 'NIU', iso2: 'NU' },
    NFK: { ioc: 'NFI', iso2: 'NF' },
    MNP: { ioc: 'NMA', iso2: 'MP' },
    NOR: { ioc: 'NOR', iso2: 'NO' },
    OMN: { ioc: 'OMA', iso2: 'OM' },
    PAK: { ioc: 'PAK', iso2: 'PK' },
    PLW: { ioc: 'PLW', iso2: 'PW' },
    PAN: { ioc: 'PAN', iso2: 'PA' },
    PNG: { ioc: 'PNG', iso2: 'PG' },
    PRY: { ioc: 'PAR', iso2: 'PY' },
    PER: { ioc: 'PER', iso2: 'PE' },
    PHL: { ioc: 'PHI', iso2: 'PH' },
    PCN: { ioc: null, iso2: 'PN' },
    POL: { ioc: 'POL', iso2: 'PL' },
    PRT: { ioc: 'POR', iso2: 'PT' },
    PRI: { ioc: 'PUR', iso2: 'PR' },
    QAT: { ioc: 'QAT', iso2: 'QA' },
    KOR: { ioc: 'KOR', iso2: 'KR' },
    MDA: { ioc: 'MDA', iso2: 'MD' },
    ROU: { ioc: 'ROU', iso2: 'RO' },
    RUS: { ioc: 'RUS', iso2: 'RU' },
    RWA: { ioc: 'RWA', iso2: 'RW' },
    REU: { ioc: 'REU', iso2: 'RE' },
    BLM: { ioc: null, iso2: 'BL' },
    SHN: { ioc: 'HEL', iso2: 'SH' },
    KNA: { ioc: 'SKN', iso2: 'KN' },
    LCA: { ioc: 'LCA', iso2: 'LC' },
    MAF: { ioc: null, iso2: 'MF' },
    SPM: { ioc: 'SPM', iso2: 'PM' },
    VCT: { ioc: 'VIN', iso2: 'VC' },
    WSM: { ioc: 'SAM', iso2: 'WS' },
    SMR: { ioc: 'SMR', iso2: 'SM' },
    STP: { ioc: 'STP', iso2: 'ST' },
    null: { ioc: null, iso2: null },
    SAU: { ioc: 'KSA', iso2: 'SA' },
    SEN: { ioc: 'SEN', iso2: 'SN' },
    SRB: { ioc: 'SRB', iso2: 'RS' },
    SYC: { ioc: 'SEY', iso2: 'SC' },
    SLE: { ioc: 'SLE', iso2: 'SL' },
    SGP: { ioc: 'SIN', iso2: 'SG' },
    SXM: { ioc: null, iso2: 'SX' },
    SVK: { ioc: 'SVK', iso2: 'SK' },
    SVN: { ioc: 'SLO', iso2: 'SI' },
    SLB: { ioc: 'SOL', iso2: 'SB' },
    SOM: { ioc: 'SOM', iso2: 'SO' },
    ZAF: { ioc: 'RSA', iso2: 'ZA' },
    SGS: { ioc: null, iso2: 'GS' },
    SSD: { ioc: null, iso2: 'SS' },
    ESP: { ioc: 'ESP', iso2: 'ES' },
    LKA: { ioc: 'SRI', iso2: 'LK' },
    PSE: { ioc: 'PLE', iso2: 'PS' },
    SDN: { ioc: 'SUD', iso2: 'SD' },
    SUR: { ioc: 'SUR', iso2: 'SR' },
    SJM: { ioc: null, iso2: 'SJ' },
    SWZ: { ioc: 'SWZ', iso2: 'SZ' },
    SWE: { ioc: 'SWE', iso2: 'SE' },
    CHE: { ioc: 'SUI', iso2: 'CH' },
    SYR: { ioc: 'SYR', iso2: 'SY' },
    TJK: { ioc: 'TJK', iso2: 'TJ' },
    THA: { ioc: 'THA', iso2: 'TH' },
    MKD: { ioc: 'MKD', iso2: 'MK' },
    TLS: { ioc: 'TLS', iso2: 'TL' },
    TGO: { ioc: 'TOG', iso2: 'TG' },
    TKL: { ioc: null, iso2: 'TK' },
    TON: { ioc: 'TGA', iso2: 'TO' },
    TTO: { ioc: 'TTO', iso2: 'TT' },
    TUN: { ioc: 'TUN', iso2: 'TN' },
    TUR: { ioc: 'TUR', iso2: 'TR' },
    TKM: { ioc: 'TKM', iso2: 'TM' },
    TCA: { ioc: 'TKS', iso2: 'TC' },
    TUV: { ioc: 'TUV', iso2: 'TV' },
    UGA: { ioc: 'UGA', iso2: 'UG' },
    UKR: { ioc: 'UKR', iso2: 'UA' },
    ARE: { ioc: 'UAE', iso2: 'AE' },
    GBR: { ioc: 'GBR', iso2: 'GB' },
    TZA: { ioc: 'TAN', iso2: 'TZ' },
    UMI: { ioc: null, iso2: 'UM' },
    VIR: { ioc: 'ISV', iso2: 'VI' },
    USA: { ioc: 'USA', iso2: 'US' },
    URY: { ioc: 'URU', iso2: 'UY' },
    UZB: { ioc: 'UZB', iso2: 'UZ' },
    VUT: { ioc: 'VAN', iso2: 'VU' },
    VEN: { ioc: 'VEN', iso2: 'VE' },
    VNM: { ioc: 'VIE', iso2: 'VN' },
    WLF: { ioc: 'WAF', iso2: 'WF' },
    ESH: { ioc: null, iso2: 'EH' },
    YEM: { ioc: 'YEM', iso2: 'YE' },
    ZMB: { ioc: 'ZAM', iso2: 'ZM' },
    ZWE: { ioc: 'ZIM', iso2: 'ZW' },
    ALA: { ioc: null, iso2: 'AX' },
};

export const icoCountries: {
    [key: string]: { iso2: string | null; iso3: string | null };
} = {
    TPE: { iso2: 'TW', iso3: 'TWN' },
    AFG: { iso2: 'AF', iso3: 'AFG' },
    ALB: { iso2: 'AL', iso3: 'ALB' },
    ALG: { iso2: 'DZ', iso3: 'DZA' },
    ASA: { iso2: 'AS', iso3: 'ASM' },
    AND: { iso2: 'AD', iso3: 'AND' },
    ANG: { iso2: 'AO', iso3: 'AGO' },
    AIA: { iso2: 'AI', iso3: 'AIA' },
    ANT: { iso2: 'AG', iso3: 'ATG' },
    ARG: { iso2: 'AR', iso3: 'ARG' },
    ARM: { iso2: 'AM', iso3: 'ARM' },
    ARU: { iso2: 'AW', iso3: 'ABW' },
    AUS: { iso2: 'AU', iso3: 'AUS' },
    AUT: { iso2: 'AT', iso3: 'AUT' },
    AZE: { iso2: 'AZ', iso3: 'AZE' },
    BAH: { iso2: 'BS', iso3: 'BHS' },
    BRN: { iso2: 'BH', iso3: 'BHR' },
    BAN: { iso2: 'BD', iso3: 'BGD' },
    BAR: { iso2: 'BB', iso3: 'BRB' },
    BLR: { iso2: 'BY', iso3: 'BLR' },
    BEL: { iso2: 'BE', iso3: 'BEL' },
    BIZ: { iso2: 'BZ', iso3: 'BLZ' },
    BEN: { iso2: 'BJ', iso3: 'BEN' },
    BER: { iso2: 'BM', iso3: 'BMU' },
    BHU: { iso2: 'BT', iso3: 'BTN' },
    BOL: { iso2: 'BO', iso3: 'BOL' },
    AHO: { iso2: 'BQ', iso3: 'BES' },
    BIH: { iso2: 'BA', iso3: 'BIH' },
    BOT: { iso2: 'BW', iso3: 'BWA' },
    BRA: { iso2: 'BR', iso3: 'BRA' },
    IVB: { iso2: 'VG', iso3: 'VGB' },
    BRU: { iso2: 'BN', iso3: 'BRN' },
    BUL: { iso2: 'BG', iso3: 'BGR' },
    BUR: { iso2: 'BF', iso3: 'BFA' },
    BDI: { iso2: 'BI', iso3: 'BDI' },
    CPV: { iso2: 'CV', iso3: 'CPV' },
    CAM: { iso2: 'KH', iso3: 'KHM' },
    CMR: { iso2: 'CM', iso3: 'CMR' },
    CAN: { iso2: 'CA', iso3: 'CAN' },
    CAY: { iso2: 'KY', iso3: 'CYM' },
    CAF: { iso2: 'CF', iso3: 'CAF' },
    CHA: { iso2: 'TD', iso3: 'TCD' },
    CHI: { iso2: 'CL', iso3: 'CHL' },
    CHN: { iso2: 'CN', iso3: 'CHN' },
    HKG: { iso2: 'HK', iso3: 'HKG' },
    MAC: { iso2: 'MO', iso3: 'MAC' },
    COL: { iso2: 'CO', iso3: 'COL' },
    COM: { iso2: 'KM', iso3: 'COM' },
    CGO: { iso2: 'CG', iso3: 'COG' },
    COK: { iso2: 'CK', iso3: 'COK' },
    CRC: { iso2: 'CR', iso3: 'CRI' },
    CRO: { iso2: 'HR', iso3: 'HRV' },
    CUB: { iso2: 'CU', iso3: 'CUB' },
    CYP: { iso2: 'CY', iso3: 'CYP' },
    CZE: { iso2: 'CZ', iso3: 'CZE' },
    CIV: { iso2: 'CI', iso3: 'CIV' },
    PRK: { iso2: 'KP', iso3: 'PRK' },
    COD: { iso2: 'CD', iso3: 'COD' },
    DEN: { iso2: 'DK', iso3: 'DNK' },
    DJI: { iso2: 'DJ', iso3: 'DJI' },
    DMA: { iso2: 'DM', iso3: 'DMA' },
    DOM: { iso2: 'DO', iso3: 'DOM' },
    ECU: { iso2: 'EC', iso3: 'ECU' },
    EGY: { iso2: 'EG', iso3: 'EGY' },
    ESA: { iso2: 'SV', iso3: 'SLV' },
    GEQ: { iso2: 'GQ', iso3: 'GNQ' },
    ERI: { iso2: 'ER', iso3: 'ERI' },
    EST: { iso2: 'EE', iso3: 'EST' },
    ETH: { iso2: 'ET', iso3: 'ETH' },
    FLK: { iso2: 'FK', iso3: 'FLK' },
    FAR: { iso2: 'FO', iso3: 'FRO' },
    FIJ: { iso2: 'FJ', iso3: 'FJI' },
    FIN: { iso2: 'FI', iso3: 'FIN' },
    FRA: { iso2: 'FR', iso3: 'FRA' },
    FGU: { iso2: 'GF', iso3: 'GUF' },
    FPO: { iso2: 'PF', iso3: 'PYF' },
    GAB: { iso2: 'GA', iso3: 'GAB' },
    GAM: { iso2: 'GM', iso3: 'GMB' },
    GEO: { iso2: 'GE', iso3: 'GEO' },
    GER: { iso2: 'DE', iso3: 'DEU' },
    GHA: { iso2: 'GH', iso3: 'GHA' },
    GIB: { iso2: 'GI', iso3: 'GIB' },
    GRE: { iso2: 'GR', iso3: 'GRC' },
    GRL: { iso2: 'GL', iso3: 'GRL' },
    GRN: { iso2: 'GD', iso3: 'GRD' },
    GUD: { iso2: 'GP', iso3: 'GLP' },
    GUM: { iso2: 'GU', iso3: 'GUM' },
    GUA: { iso2: 'GT', iso3: 'GTM' },
    GUI: { iso2: 'GN', iso3: 'GIN' },
    GBS: { iso2: 'GW', iso3: 'GNB' },
    GUY: { iso2: 'GY', iso3: 'GUY' },
    HAI: { iso2: 'HT', iso3: 'HTI' },
    HON: { iso2: 'HN', iso3: 'HND' },
    HUN: { iso2: 'HU', iso3: 'HUN' },
    ISL: { iso2: 'IS', iso3: 'ISL' },
    IND: { iso2: 'IN', iso3: 'IND' },
    INA: { iso2: 'ID', iso3: 'IDN' },
    IRI: { iso2: 'IR', iso3: 'IRN' },
    IRQ: { iso2: 'IQ', iso3: 'IRQ' },
    IRL: { iso2: 'IE', iso3: 'IRL' },
    ISR: { iso2: 'IL', iso3: 'ISR' },
    ITA: { iso2: 'IT', iso3: 'ITA' },
    JAM: { iso2: 'JM', iso3: 'JAM' },
    JPN: { iso2: 'JP', iso3: 'JPN' },
    JOR: { iso2: 'JO', iso3: 'JOR' },
    KAZ: { iso2: 'KZ', iso3: 'KAZ' },
    KEN: { iso2: 'KE', iso3: 'KEN' },
    KIR: { iso2: 'KI', iso3: 'KIR' },
    KUW: { iso2: 'KW', iso3: 'KWT' },
    KGZ: { iso2: 'KG', iso3: 'KGZ' },
    LAO: { iso2: 'LA', iso3: 'LAO' },
    LAT: { iso2: 'LV', iso3: 'LVA' },
    LIB: { iso2: 'LB', iso3: 'LBN' },
    LES: { iso2: 'LS', iso3: 'LSO' },
    LBR: { iso2: 'LR', iso3: 'LBR' },
    LBA: { iso2: 'LY', iso3: 'LBY' },
    LIE: { iso2: 'LI', iso3: 'LIE' },
    LTU: { iso2: 'LT', iso3: 'LTU' },
    LUX: { iso2: 'LU', iso3: 'LUX' },
    MAD: { iso2: 'MG', iso3: 'MDG' },
    MAW: { iso2: 'MW', iso3: 'MWI' },
    MAS: { iso2: 'MY', iso3: 'MYS' },
    MDV: { iso2: 'MV', iso3: 'MDV' },
    MLI: { iso2: 'ML', iso3: 'MLI' },
    MLT: { iso2: 'MT', iso3: 'MLT' },
    MSH: { iso2: 'MH', iso3: 'MHL' },
    MRT: { iso2: 'MQ', iso3: 'MTQ' },
    MTN: { iso2: 'MR', iso3: 'MRT' },
    MRI: { iso2: 'MU', iso3: 'MUS' },
    MAY: { iso2: 'YT', iso3: 'MYT' },
    MEX: { iso2: 'MX', iso3: 'MEX' },
    FSM: { iso2: 'FM', iso3: 'FSM' },
    MON: { iso2: 'MC', iso3: 'MCO' },
    MGL: { iso2: 'MN', iso3: 'MNG' },
    MGO: { iso2: 'ME', iso3: 'MNE' },
    MNT: { iso2: 'MS', iso3: 'MSR' },
    MAR: { iso2: 'MA', iso3: 'MAR' },
    MOZ: { iso2: 'MZ', iso3: 'MOZ' },
    MYA: { iso2: 'MM', iso3: 'MMR' },
    NAM: { iso2: 'NA', iso3: 'NAM' },
    NRU: { iso2: 'NR', iso3: 'NRU' },
    NEP: { iso2: 'NP', iso3: 'NPL' },
    NED: { iso2: 'NL', iso3: 'NLD' },
    NCD: { iso2: 'NC', iso3: 'NCL' },
    NZL: { iso2: 'NZ', iso3: 'NZL' },
    NCA: { iso2: 'NI', iso3: 'NIC' },
    NIG: { iso2: 'NE', iso3: 'NER' },
    NGR: { iso2: 'NG', iso3: 'NGA' },
    NIU: { iso2: 'NU', iso3: 'NIU' },
    NFI: { iso2: 'NF', iso3: 'NFK' },
    NMA: { iso2: 'MP', iso3: 'MNP' },
    NOR: { iso2: 'NO', iso3: 'NOR' },
    OMA: { iso2: 'OM', iso3: 'OMN' },
    PAK: { iso2: 'PK', iso3: 'PAK' },
    PLW: { iso2: 'PW', iso3: 'PLW' },
    PAN: { iso2: 'PA', iso3: 'PAN' },
    PNG: { iso2: 'PG', iso3: 'PNG' },
    PAR: { iso2: 'PY', iso3: 'PRY' },
    PER: { iso2: 'PE', iso3: 'PER' },
    PHI: { iso2: 'PH', iso3: 'PHL' },
    POL: { iso2: 'PL', iso3: 'POL' },
    POR: { iso2: 'PT', iso3: 'PRT' },
    PUR: { iso2: 'PR', iso3: 'PRI' },
    QAT: { iso2: 'QA', iso3: 'QAT' },
    KOR: { iso2: 'KR', iso3: 'KOR' },
    MDA: { iso2: 'MD', iso3: 'MDA' },
    ROU: { iso2: 'RO', iso3: 'ROU' },
    RUS: { iso2: 'RU', iso3: 'RUS' },
    RWA: { iso2: 'RW', iso3: 'RWA' },
    REU: { iso2: 'RE', iso3: 'REU' },
    HEL: { iso2: 'SH', iso3: 'SHN' },
    SKN: { iso2: 'KN', iso3: 'KNA' },
    LCA: { iso2: 'LC', iso3: 'LCA' },
    SPM: { iso2: 'PM', iso3: 'SPM' },
    VIN: { iso2: 'VC', iso3: 'VCT' },
    SAM: { iso2: 'WS', iso3: 'WSM' },
    SMR: { iso2: 'SM', iso3: 'SMR' },
    STP: { iso2: 'ST', iso3: 'STP' },
    KSA: { iso2: 'SA', iso3: 'SAU' },
    SEN: { iso2: 'SN', iso3: 'SEN' },
    SRB: { iso2: 'RS', iso3: 'SRB' },
    SEY: { iso2: 'SC', iso3: 'SYC' },
    SLE: { iso2: 'SL', iso3: 'SLE' },
    SIN: { iso2: 'SG', iso3: 'SGP' },
    SVK: { iso2: 'SK', iso3: 'SVK' },
    SLO: { iso2: 'SI', iso3: 'SVN' },
    SOL: { iso2: 'SB', iso3: 'SLB' },
    SOM: { iso2: 'SO', iso3: 'SOM' },
    RSA: { iso2: 'ZA', iso3: 'ZAF' },
    ESP: { iso2: 'ES', iso3: 'ESP' },
    SRI: { iso2: 'LK', iso3: 'LKA' },
    PLE: { iso2: 'PS', iso3: 'PSE' },
    SUD: { iso2: 'SD', iso3: 'SDN' },
    SUR: { iso2: 'SR', iso3: 'SUR' },
    SWZ: { iso2: 'SZ', iso3: 'SWZ' },
    SWE: { iso2: 'SE', iso3: 'SWE' },
    SUI: { iso2: 'CH', iso3: 'CHE' },
    SYR: { iso2: 'SY', iso3: 'SYR' },
    TJK: { iso2: 'TJ', iso3: 'TJK' },
    THA: { iso2: 'TH', iso3: 'THA' },
    MKD: { iso2: 'MK', iso3: 'MKD' },
    TLS: { iso2: 'TL', iso3: 'TLS' },
    TOG: { iso2: 'TG', iso3: 'TGO' },
    TGA: { iso2: 'TO', iso3: 'TON' },
    TTO: { iso2: 'TT', iso3: 'TTO' },
    TUN: { iso2: 'TN', iso3: 'TUN' },
    TUR: { iso2: 'TR', iso3: 'TUR' },
    TKM: { iso2: 'TM', iso3: 'TKM' },
    TKS: { iso2: 'TC', iso3: 'TCA' },
    TUV: { iso2: 'TV', iso3: 'TUV' },
    UGA: { iso2: 'UG', iso3: 'UGA' },
    UKR: { iso2: 'UA', iso3: 'UKR' },
    UAE: { iso2: 'AE', iso3: 'ARE' },
    GBR: { iso2: 'GB', iso3: 'GBR' },
    TAN: { iso2: 'TZ', iso3: 'TZA' },
    ISV: { iso2: 'VI', iso3: 'VIR' },
    USA: { iso2: 'US', iso3: 'USA' },
    URU: { iso2: 'UY', iso3: 'URY' },
    UZB: { iso2: 'UZ', iso3: 'UZB' },
    VAN: { iso2: 'VU', iso3: 'VUT' },
    VEN: { iso2: 'VE', iso3: 'VEN' },
    VIE: { iso2: 'VN', iso3: 'VNM' },
    WAF: { iso2: 'WF', iso3: 'WLF' },
    YEM: { iso2: 'YE', iso3: 'YEM' },
    ZAM: { iso2: 'ZM', iso3: 'ZMB' },
    ZIM: { iso2: 'ZW', iso3: 'ZWE' },
};

/**
 * Converts ISO3 country code to ISO2 country code for flag display
 * @param iso3Code - The ISO3 country code (e.g., 'USA', 'GBR')
 * @returns The ISO2 country code (e.g., 'us', 'gb') or the original code if not found
 */
export const iso3ToIso2 = (iso3Code: string): string | undefined => {
    if (!iso3Code) return undefined;

    const country = iso3Countries[iso3Code.toUpperCase()];
    if (country && country.iso2) {
        return country.iso2;
    }

    // If not found in our map, return the original code (might work for some cases)
    console.warn(`ISO3 country code not found in mapping: ${iso3Code}`);
    return undefined;
};

export const iso2ToIso3 = (iso2Code: string): string | undefined => {
    if (!iso2Code) return undefined;

    const country = iso2Countries[iso2Code.toUpperCase()];
    if (country && country.iso3) {
        return country.iso3;
    }

    // If not found in our map, return the original code (might work for some cases)
    console.warn(`ISO2 country code not found in mapping: ${iso2Code}`);
    return undefined;
};

// Maps an ISO2 country code to its IOC code, or undefined when there is no IOC equivalent.
export const iso2ToIoc = (iso2Code: string): string | undefined => {
    if (!iso2Code) return undefined;
    return iso2Countries[iso2Code.toUpperCase()]?.ioc ?? undefined;
};

// Normalises an ISO3 or IOC country code to its IOC code (stored country codes are a mix of both).
export const toIocCode = (code: string): string | undefined => {
    if (!code) return undefined;
    const upper = code.toUpperCase();
    if (icoCountries[upper]) return upper;
    return iso3Countries[upper]?.ioc ?? undefined;
};
